/**
 * Created by 马荣钦 on 2016/1/21.
 */
angular
    .module('myZonePerInfoInfoModule', [
        'myZoneProInfoInfoRouterModule',
        'myZoneProInfoModifyModule',
        'zoneServiceModule', // 修改头像原来的流程
    ])
    .controller('myZonePerInfoInfoCtrl', [
        '$scope',
        '$validation',
        '$q',
        '$rootScope',
        'trsHttpService',
        'modalDialog',
        'Upload',
        'zoneService',
        'editingCenterService',
        'messagePublishService',
        'jsonArrayToStringService',
        function (
            $scope,
            $validation,
            $q,
            $rootScope,
            trsHttpService,
            modalDialog,
            Upload,
            zoneService,
            editingCenterService,
            messagePublishService,
            jsonArrayToStringService
        ) {
            initStatus();
            initData();

            /**
             * [initStatus description]
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.params = {
                    serviceid: 'mlf_extuser',
                    methodname: 'getCurrUserInfo',
                };
                $scope.headPic = '';
                $scope.status = {
                    modify: false,
                };
                $scope.selectSex = '';
                $scope.data = {
                    bankInfos: [
                        {
                            name: '选择开户行',
                            value: 0,
                        },
                        {
                            name: '工商银行',
                            value: 1,
                        },
                        {
                            name: '农业银行',
                            value: 2,
                        },
                        {
                            name: '中国银行',
                            value: 3,
                        },
                        {
                            name: '建设银行',
                            value: 4,
                        },
                        {
                            name: '交通银行',
                            value: 5,
                        },
                        {
                            name: '上海浦东发展银行',
                            value: 6,
                        },
                        {
                            name: '兴业银行',
                            value: 7,
                        },
                        {
                            name: '光大银行',
                            value: 8,
                        },
                        {
                            name: '深圳发展银行',
                            value: 9,
                        },
                        {
                            name: '民生银行',
                            value: 10,
                        },
                        {
                            name: '中信银行',
                            value: 11,
                        },
                        {
                            name: '招商银行',
                            value: 12,
                        },
                        {
                            name: '广东发展银行',
                            value: 13,
                        },
                        {
                            name: '华夏银行',
                            value: 14,
                        },
                        {
                            name: '其他银行',
                            value: 15,
                        },
                    ],
                };
            }

            /**
             * [initData description]初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                requestData().then(function (data) {
                    initBankSelect(data);
                });
                headPortrait();
                requestGroup();
                // loadBankInfoCheck();
            }

            /**
             * [requestZoneInfo description]
             * @return {[type]} [description]
             */
            $scope.requestData = requestData;


            /**
             * [requestGroup description] 请求组织
             * @return {[type]} [description]
             */
            function requestGroup() {
                var params = {
                    methodname: 'queryGroups',
                    serviceid: 'mlf_extuser',
                };
                trsHttpService
                    .httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                    .then(function (data) {
                        for (var i = 0; i < data.length; i++) {
                            data[i].GROUPPATH = data[i].GROUPPATH.slice(0, -1);
                        }
                        $scope.data.groups = data;
                    });
            }

            /**
             * [requestData description]
             * @return  {[type]}  [return description]
             */
            function requestData() {
                var defer = $q.defer();
                trsHttpService
                    .httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get')
                    .then(function (data) {
                        $scope.info = data; // 8
                        defer.resolve(data);
                    });
                return defer.promise;
            }

            /**
             * [initBankSelect description]
             * @param   {[type]}  data  [data description]
             * @return  {[type]}        [return description]
             */
            function initBankSelect(data) {
                if (!data.BANKACCOUNT) {
                    $scope.data.selectBank = $scope.data.bankInfos[0];
                } else {
                    for (var i = 0; i < $scope.data.bankInfos.length; i++) {
                        if ($scope.data.bankInfos[i].name == data.BANKACCOUNT) {
                            $scope.data.selectBank = $scope.data.bankInfos[i];
                            break;
                        }
                    }
                }
            }

            /**
             * [headPortrait description]获取头像
             * @param   {[type]}  flag  [flag description]
             * @return  {[type]}        [return description]
             */
            function headPortrait(flag) {
                editingCenterService.getUserHeadPic(flag).then(function (data) {
                    $scope.headPic = data;
                });
            }

            /**
             * [saveInfo description]保存信息
             * @return  {[type]}  [return description]
             */
            $scope.saveInfo = function () {
                $validation
                    .validate($scope.personalInfoname)
                    .success(function () {
                        trsHttpService
                            .httpServer(trsHttpService.getWCMRootUrl(), saveParams(), 'post')
                            .then(function () {
                                messagePublishService.publish('headPortrait', '');
                                modalDialog.alertType('提交成功', '', 'success', false);
                            });
                    })
                    .error(function () {
                        modalDialog.alertType('保存失败', '请检查填写项', 'error', 'confirm');
                    });
            };

            /**
             * [saveParams description] 保存信息要的参数
             * @return {[type]} [description]
             */
            function saveParams() {
                $scope.info.USERIDCARD = angular.copy($scope.info.FGDSFZ);
                var params = angular.copy($scope.info);
                params.serviceid = 'mlf_extuser';
                params.methodname = 'saveCurrUser';
                params.USERIDCARD = angular.copy($scope.info.FGDSFZ);
                params.TEL = params.TELEPHONE;
                params.BANKACCOUNT =
                    $scope.data.selectBank.name == '选择开户行' ? '' : $scope.data.selectBank.name;
                delete params.TELEPHONE;
                delete params.FGDSFZ;
                delete params.ID;
                delete params.COMPANY;
                delete params.DEPT;
                delete params.TRUENAME;
                delete params.USERNUM;
                return jsonArrayToStringService.jsonArrayToString(params);
            }

            /**
             * [changeHeadPortrait description]  更换头像
             * @param  {[type]} files    [description]
             * @param  {[type]} file     [description]
             * @param  {[type]} newFiles [description]
             * @return {[type]}          [description]
             */
            $scope.changeHeadPortrait = function (files, file, newFiles) {
                var imgType = ['jpg', 'jpeg', 'png', 'bmp', 'gif', ],
                    fileType = newFiles[0].name
                        .substr(newFiles[0].name.lastIndexOf('.') + 1)
                        .toLowerCase();
                if (imgType.indexOf(fileType) < 0) {
                    modalDialog.alertType('格式不支持', '', 'warning', false);
                    return;
                }
                Upload.upload({
                    url: '/wcm/openapi/uploadImage',
                    data: {
                        file: newFiles[0],
                    },
                }).then(function (resp) {
                    var imgSrc = '/wcm/openapi/readimg?FileName=' + resp.data.imgName;
                    var imgSize = '100,100';
                    zoneService.newCropperHeaderlogo(imgSrc, imgSize).then(function (result) {
                        $scope.headPic = result.imgSrc;
                        var params = {
                            serviceid: 'mlf_extuser',
                            methodname: 'saveUserHead',
                            UserHead: [
                                {
                                    appFile: result.imgName,
                                    appDesc: result.imgName,
                                    PERPICURL: result.imgSrc,
                                },
                            ],
                        };
                        params.UserHead = JSON.stringify(params.UserHead);
                        trsHttpService
                            .httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                            .then(function () {
                                $rootScope.$emit('updateHeadPortrait');
                                headPortrait(true);
                                modalDialog.alertType('头像修改成功', '', 'success', false);
                            });
                    });
                });
            };

            /**
             * [modifyInfo description]   更换 邮箱 电话
             * @param  {[type]} type [description]  email  tel
             * @return {[type]}      [description]
             */
            $scope.modifyInfo = function (type) {
                zoneService.modifyChartInfo(saveParams(), type, $scope.requestData);
            };
        },
    ]);
